<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="orders">
    <v-row class="d-md-flex align-center">
      <v-col
        ><h1>{{ $t("orders") }}</h1></v-col
      >
      <v-col cols="12" md="4" class="d-flex justify-end"> </v-col>
      <v-col
        class="filter-box d-flex justify-end flex-md-row flex-column"
        cols="12"
        md="4"
      >
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn
              class="mr-6 mb-6 mb-md-0"
              v-if="isModifyCmrs"
              v-on="on"
              fab
              color="#08a657"
              @click="addItem()"
              :disabled="isDisabledCreate()"
            >
              <v-icon color="#ffffff">mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("crm.addCmr") }}</span>
        </v-tooltip>
        <v-btn
          v-if="isPionira"
          class="btn-two mobile-block pionira-btn mb-6 mb-md-0"
          color="#08a657"
          height="56px"
          depressed
          @click.stop="showPionira"
        >
          {{ $t("crm.crossPlatformSigning") }}
        </v-btn>
        <v-btn
          class="btn-two mobile-block"
          color="#08a657"
          height="56px"
          depressed
          @click.stop="showFilterSearchForm"
        >
          <v-icon medium>mdi-filter-outline</v-icon>
          {{ $t("crm.filter_search_button") }}
          <v-icon medium class="ml-3">mdi-magnify</v-icon>
        </v-btn>
      </v-col>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-col cols="12" md="1">
            <v-btn
              height="56px"
              class="bg-white"
              color="#e3e9ed"
              block
              text
              outlined
              v-on="on"
            >
              <v-icon color="#4f526c">mdi-cog</v-icon>
              <v-icon color="#4f526c">mdi-chevron-down</v-icon>
            </v-btn>
          </v-col>
        </template>
        <v-list class="menu-open">
          <!--                    <v-list-item link height="40">-->
          <!--                        <v-list-item-icon>-->
          <!--                            <v-icon large color="#5b8ff5">mdi-export</v-icon>-->
          <!--                        </v-list-item-icon>-->
          <!--                        <v-list-item-content>-->
          <!--                            <v-list-item-title>{{ $t('crm.export_xls') }}</v-list-item-title>-->
          <!--                        </v-list-item-content>-->
          <!--                    </v-list-item>-->
          <v-list-item link height="40" @click="printOrder()">
            <v-list-item-icon>
              <v-icon large color="#5b8ff5">mdi-printer</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t("crm.print") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-row>
    <v-row>
      <v-col col="12">
        <v-expand-transition>
          <v-row
            class="transition-display brd-top-vone"
            v-show="showPioniraForm"
          >
            <v-col cols="12">
              <v-text-field
                :placeholder="$t('crm.cmrCode')"
                outlined
                hide-details
                v-model="pioniraCmrCode"
                background-color="#fff"
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                :placeholder="$t('crm.comment')"
                outlined
                hide-details
                v-model="pioniraComment"
                background-color="#fff"
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3" lg="2">
              <v-btn
                height="56px"
                class="btn-one"
                block
                text
                depressed
                @click="showPionira"
              >
                <span>{{ $t("cancel") }}</span>
              </v-btn>
            </v-col>
            <v-col cols="12" md="3" lg="2">
              <v-btn
                class="btn-two"
                color="#08a657"
                height="56px"
                block
                depressed
                dark
                @click="applyPionira()"
              >
                <span>{{ $t("crm.sign") }}</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-expand-transition>
        <v-expand-transition>
          <v-row class="transition-display brd-top-vone" v-show="showSearch">
            <v-col cols="12" md="6" lg="8">
              <v-text-field
                :placeholder="$t('crm.search')"
                outlined
                hide-details
                v-model="searchStr"
                background-color="#fff"
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3" lg="2">
              <v-btn
                height="56px"
                class="btn-one"
                block
                text
                depressed
                @click="hideFilter"
              >
                <span>{{ $t("cancel") }}</span>
              </v-btn>
            </v-col>
            <v-col cols="12" md="3" lg="2">
              <v-btn
                class="btn-two"
                color="#08a657"
                height="56px"
                block
                depressed
                dark
                @click="applyFilter('status')"
              >
                <span>{{ $t("apply") }}</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-expand-transition>
        <v-expand-transition>
          <v-row
            class="transition-display brd-top-vone"
            v-show="showDateFilter"
          >
            <v-col cols="12" md="4" lg="4">
              <v-dialog
                ref="dialogCalendar"
                v-model="modalCalendar"
                :return-value.sync="date"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="dateRangeText"
                    :label="$t('crm.date_range')"
                    prepend-icon="mdi-calendar"
                    :class="{ 'date-range-custom-field': isCustomDateRange }"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="date"
                  scrollable
                  range
                  header-color="primary"
                  color="primary"
                  no-title
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="cancelCalendar">{{
                    $t("cancel")
                  }}</v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.dialogCalendar.save(date)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>

            <v-col cols="12" md="3" lg="2" class="past-two-weeks-col">
              <label class="checkbox-one past-two-weeks-checkbox">
                <span>{{ $t("crm.past_two_weeks") }}</span>
                <input type="checkbox" v-model="pastTwoWeeksChecked" />
                <span class="checkmark"></span>
              </label>
            </v-col>

            <v-col cols="12" md="4" lg="4">
              <v-select
                class="select-box"
                background-color="#fff"
                :placeholder="$t('crm.period_search')"
                outlined
                large
                hide-details
                :items="periodSearchType"
                v-model="selectedPeriodSearch"
                return-object
                item-text="name"
                clearable
                @click:clear="clearPeriodSearch"
              >
                <template v-slot:append>
                  <v-icon size="30" color="#5b8ff5">mdi-chevron-down</v-icon>
                </template>
                <template v-slot:{item}>
                  <span>{{ item }}</span>
                </template>
              </v-select>
            </v-col>
          </v-row>
        </v-expand-transition>
        <v-expand-transition>
          <v-row
            class="transition-display brd-top-vone"
            v-show="showStatusNameFilter"
          >
            <v-col cols="12">
              <v-row>
                <v-col cols="12">
                  <label
                    class="checkbox-one"
                    :class="{ 'checkbox-one--part': isChbxPart }"
                  >
                    <span>{{ $t("crm.checked_all") }}</span>
                    <input
                      type="checkbox"
                      v-model="chbxCheckedAll"
                      @click="selectAll"
                    />
                    <span class="checkmark"></span>
                  </label>
                  <v-divider class="mt-6 brdr-top-gray"></v-divider>
                </v-col>
                <v-col
                  v-for="i in checkBoxList"
                  :key="i.id"
                  col
                  class="basis200 flex-grow-0 flex-shrink-0"
                >
                  <label class="checkbox-one">
                    {{ $t(i.t) }}
                    <input
                      type="checkbox"
                      :value="i.model"
                      v-model="chbxFilters"
                    />
                    <span class="checkmark"></span>
                  </label>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-expand-transition>
        <v-expand-transition>
          <v-row>
            <v-col cols="12">
              <div v-if="resultStr">
                <div>
                  <v-chip
                    v-if="searchStr"
                    class="ma-1"
                    close
                    @click:close="removeFilterItemStr()"
                    small
                  >
                    <strong>{{ $t("crm.search_by") }}</strong
                    >: "{{ searchStr }}"
                  </v-chip>
                  <v-chip
                    v-for="(el, i) in chbxFilters"
                    :key="i"
                    class="ma-1"
                    close
                    @click:close="removeFilterItem(el)"
                    small
                  >
                    {{ getFilterName(el) }}
                  </v-chip>
                  <v-chip
                    v-if="date.length !== 0"
                    :class="[
                      'ma-1',
                      { 'date-range-custom-chip': isCustomDateRange },
                    ]"
                    close
                    @click:close="removeFilterItemData"
                    small
                  >
                    <strong>{{ $t("crm.date_range") }}</strong
                    >: "{{ date.join(" ~ ") }}"
                  </v-chip>
                  <v-chip
                    v-if="periodSearchStr"
                    class="ma-1"
                    close
                    @click:close="clearPeriodSearch"
                    small
                  >
                    <strong>{{ $t("crm.period_search") }}</strong
                    >: "{{ periodSearchStr }}"
                  </v-chip>
                  <v-chip
                    v-if="
                      periodSearchStr ||
                        date.length !== 0 ||
                        searchStr ||
                        chbxFilters.length !== 0
                    "
                    class="ma-1"
                    close
                    @click:close="removeFilterAll()"
                    small
                    outlined
                  >
                    <strong>{{ $t("clear") }}</strong>
                  </v-chip>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-expand-transition>
        <v-card>
          <v-data-table
            :headers="tableHeaders"
            :items="cmrData"
            class="elevation-1"
            :options.sync="options"
            :items-per-page="options.rowsPerPageItems"
            :server-items-length="totalItems"
            :loading="this.$store.state.loading"
            :footer-props="{
              'items-per-page-options': this.$store.state.rowsPerPageItems,
              'items-per-page-text': $t('rowsPerPage'),
            }"
            id="print-order-table"
            :no-data-text="$t('noDataAvailable')"
            :sort-by.sync="options.sortBy"
            :sort-desc.sync="options.lastModified"
          >
            <template v-slot:header.checkbox="{ header }">
              <v-checkbox
                v-model="selectedCmrAll"
                value="all"
                color="#5b8ff5"
                :indeterminate="selectedCmrAllIndeterminate"
              ></v-checkbox>
            </template>

            <template v-slot:item.checkbox="{ item }">
              <v-checkbox
                v-model="selectedCmr"
                :value="item.id"
                color="#5b8ff5"
              ></v-checkbox>
            </template>

            <template v-slot:item.qrCode="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="getQRCode(item)"
                    fab
                    small
                    color="#fff"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="#5b8ff5"> mdi-qrcode </v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("crm.QRCodeCMR") }}</span>
              </v-tooltip>
            </template>

            <template v-slot:item.statusName="{ item }">
              <span :style="statusNameColor(item)">{{ item.statusName }}</span>
            </template>

            <template v-slot:item.edit="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="editItem(item)"
                    :disabled="editDisabled(item)"
                    fab
                    small
                    color="#fff"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="#5b8ff5"> mdi-pencil-outline </v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("crm.editCMR") }}</span>
              </v-tooltip>
            </template>

            <template v-slot:item.delete="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="itemDelete(item)"
                    :disabled="deleteDisabled()"
                    fab
                    small
                    color="#fff"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="#5b8ff5"> mdi-delete </v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("crm.deleteCMR") }}</span>
              </v-tooltip>
            </template>

            <template v-slot:item.pdfFile="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="generatePdf(item)"
                    fab
                    small
                    color="#fff"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="#5b8ff5">mdi-file-pdf-box</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("crm.viewCMR") }}</span>
              </v-tooltip>
            </template>

            <template v-slot:item.sign="{ item }">
              <v-btn
                fab
                small
                color="#fff"
                @click="signDocument(item)"
                :style="showSighihgButton()"
                :disabled="signDisabled()"
              >
                <v-icon color="#5b8ff5"> mdi-signature-text </v-icon>
              </v-btn>
            </template>

            <template v-slot:item.details="{ item }">
              <div class="d-flex">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="itemDetails(item)"
                      fab
                      small
                      color="#fff"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="#5b8ff5"> mdi-file-document </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("crm.viewDocumentDetails") }}</span>
                </v-tooltip>

                <v-tooltip top v-if="item.isUnapprovedGoods">
                  <template v-slot:activator="{ on }">
                    <span class="pl-2" v-on="on">*</span>
                  </template>
                  <span>{{ $t("crm.isUnapprovedGoods") }}</span>
                </v-tooltip>
              </div>
            </template>

            <template v-slot:item.comment="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="showCommentForm(item)"
                    fab
                    small
                    color="#fff"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="#5b8ff5"> mdi-comment-plus-outline </v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("crm.placeCommentOrEmailCMR") }}</span>
              </v-tooltip>
            </template>

            <template v-slot:item.photoCount="{ item }">
              <v-btn
                v-if="item.photoCount != 0"
                text
                icon
                color="#5b8ff5"
                @click.stop="openPhotoGallery(item)"
              >
                {{ item.photoCount }}
              </v-btn>
            </template>
            <template v-slot:item.attachmentCount="{ item }">
              <v-btn
                v-if="item.attachmentCount != 0"
                text
                icon
                color="#5b8ff5"
                @click="openAttachmentsDialog(item)"
              >
                {{ item.attachmentCount }}
              </v-btn>
            </template>
          </v-data-table>
          <vue-easy-lightbox
            escDisabled
            moveDisabled
            :visible="photoGallery.visible"
            :imgs="photoGallery.imgs.map((e) => e.src)"
            :index="photoGallery.index"
            @hide="hideHandlerPhotoGallery"
          ></vue-easy-lightbox>

          <div
            class="orders__fixed-options"
            :class="{ show: isFixedOptions && !allSelectedAreCanceled }"
          >
            <div
              class="orders__fixed-phone"
              v-if="
                canUseSpotCharter &&
                  !selectedCmrList.some(
                    (cmr) =>
                      cmr.status === 7 || cmr.status === 8 || cmr.status === 9
                  )
              "
            >
              <v-btn fab @click="handleSpotCharterModal">
                <svg
                  width="19"
                  height="26"
                  viewBox="0 0 19 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="0.5"
                    y="0.5"
                    width="14.4286"
                    height="24.7143"
                    rx="1.5"
                    stroke="black"
                  />
                  <line
                    x1="1.28571"
                    y1="3.35715"
                    x2="15.4286"
                    y2="3.35715"
                    stroke="black"
                  />
                  <line
                    x1="1.28571"
                    y1="20.0714"
                    x2="14.1429"
                    y2="20.0714"
                    stroke="black"
                  />
                  <line
                    x1="7.71428"
                    y1="22.6429"
                    x2="11.5714"
                    y2="22.6429"
                    stroke="black"
                  />
                  <path
                    d="M12.8571 14.1429V15.4286V16C12.8571 16.8241 13.7979 17.2944 14.4571 16.8L17.6 14.4429C17.8518 14.254 18 13.9576 18 13.6429V8.71429C18 8.16201 17.5523 7.71429 17 7.71429H9.35714C8.80486 7.71429 8.35714 8.16201 8.35714 8.71429V13.1429C8.35714 13.6951 8.80486 14.1429 9.35714 14.1429H12.8571Z"
                    fill="white"
                  />
                  <path
                    d="M12.8571 15.4286V14.1429M12.8571 14.1429H9.35714C8.80486 14.1429 8.35714 13.6951 8.35714 13.1429V8.71429C8.35714 8.16201 8.80486 7.71429 9.35714 7.71429H17C17.5523 7.71429 18 8.16201 18 8.71429V13.6429C18 13.9576 17.8518 14.254 17.6 14.4429L14.4571 16.8C13.7979 17.2944 12.8571 16.8241 12.8571 16V14.1429Z"
                    stroke="black"
                  />
                  <circle cx="4.5" cy="22.5" r="0.642857" fill="black" />
                  <circle cx="10.9286" cy="10.9286" r="0.642857" fill="black" />
                  <path d="M12.8571 10.9286H16.7143" stroke="black" />
                </svg>
              </v-btn>
            </div>
            <v-speed-dial
              v-model="fab"
              :bottom="true"
              :left="true"
              direction="top"
              :open-on-hover="true"
              transition="slide-y-reverse-transition"
            >
              <template v-slot:activator>
                <v-btn v-model="fab" color="blue darken-2" dark fab>
                  <v-icon v-if="fab">mdi-close</v-icon>
                  <v-icon v-else>mdi-cog</v-icon>
                </v-btn>
              </template>
              <v-tooltip right v-if="showSigningBtn()">
                <template v-slot:activator="{ on }">
                  <v-btn
                    fab
                    dark
                    small
                    color="green"
                    v-on="on"
                    @click="signMass()"
                  >
                    <v-icon>mdi-signature-text</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("crm.multiSigning") }}</span>
              </v-tooltip>
              <v-tooltip right v-if="selectedCmrList.length > 0">
                <template v-slot:activator="{ on }">
                  <v-btn
                    fab
                    dark
                    small
                    color="green"
                    v-on="on"
                    @click="openNewAttachmentDialog()"
                  >
                    <v-icon>mdi-paperclip</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("crm.attachFile") }}</span>
              </v-tooltip>
              <v-tooltip right v-if="showDriverBtn()">
                <template v-slot:activator="{ on }">
                  <v-btn
                    fab
                    dark
                    small
                    color="green"
                    v-on="on"
                    @click="addDriversMass()"
                  >
                    +
                    <v-icon>mdi-truck-delivery</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("crm.selectDriver") }}</span>
              </v-tooltip>

              <v-tooltip
                right
                v-if="
                  showSetToPrevStatusBtn() &&
                    $isPermitted('SetOrUnsetUnfinishedStatusOfCMR')
                "
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    fab
                    dark
                    small
                    color="green"
                    v-on="on"
                    @click="SetToPrevStatus()"
                  >
                    <v-icon>mdi-undo</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("crm.setToPreviousStatus") }}</span>
              </v-tooltip>

              <v-tooltip
                right
                v-if="
                  showSetToUnfinishedBtn() &&
                    $isPermitted('SetOrUnsetUnfinishedStatusOfCMR')
                "
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    fab
                    dark
                    small
                    color="green"
                    v-on="on"
                    @click="SetToUnfinished()"
                  >
                    <v-icon>mdi-redo</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("crm.setToUnfinished") }}</span>
              </v-tooltip>

              <v-tooltip right v-if="selectedCmrList.length > 0">
                <template v-slot:activator="{ on }">
                  <v-btn
                    fab
                    dark
                    small
                    color="green"
                    v-on="on"
                    @click="getQRCode()"
                  >
                    <v-icon>mdi-qrcode</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("crm.getQRCode") }}</span>
              </v-tooltip>

              <!--                            <v-btn fab dark small color="indigo">-->
              <!--                                <v-icon>mdi-plus</v-icon>-->
              <!--                            </v-btn>-->
              <!--                            <v-btn fab dark small color="red">-->
              <!--                                <v-icon>mdi-delete</v-icon>-->
              <!--                            </v-btn>-->
            </v-speed-dial>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog
      v-model="editDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <OrdersEditModal
        :close-dialog="closeEditModal"
        :edit-dialog="editDialog"
        :edit-crm-id="editCrmId"
        :is-read-only="isReadOnly"
        :reload-cmr="reloadCmr"
      />
    </v-dialog>

    <v-dialog v-model="deleteDialog" max-width="290">
      <v-card>
        <v-card-title class="headline">{{
          $t("crm.delete_order")
        }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          {{ $t("crm.order_delete_msg") }}
          <br />
          {{ $t("crm.order_delete_additional_msg") }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="deleteDialog = false">
            {{ $t("cancel") }}
          </v-btn>

          <v-btn color="green darken-1" text @click="removeItem()">
            {{ $t("crm.delete") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="signForm" max-width="400">
      <v-card>
        <v-card-title class="headline">{{
          $t("crm.sign_document")
        }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="codeFieldText"
                  :label="$t('crm.sign')"
                  required
                  outlined
                  clearable
                  :error-messages="errorMessagesCodeField"
                  counter
                  maxlength="4"
                  @keypress="onlyNumber"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  class="mx-2"
                  :label="$t('crm.comment')"
                  rows="1"
                  prepend-icon="mdi-comment"
                  auto-grow
                  clearable
                  clear-icon="mdi-close"
                  counter
                  maxlength="255"
                  v-model="commentFieldText"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="signForm = false">
            {{ $t("crm.cancel") }}
          </v-btn>

          <v-btn color="green darken-1" text @click="saveSign()">
            {{ $t("crm.sign") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="addDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="addDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t("crm.create_cmr") }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="saveOrder()">{{ $t("crm.save") }}</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-container></v-container>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showHideDialog" max-width="400">
      <v-card>
        <v-card-title>{{ $t("crm.show_hide_column") }}</v-card-title>
        <v-card-text>
          <v-divider></v-divider>
          <v-layout row wrap>
            <v-flex
              v-for="(header, index) in headerInDialog"
              :key="headerInDialog[index].value"
              xs6
            >
              <v-checkbox
                class="checkbox-vuetify"
                :label="header.text"
                v-model="header.selected"
                @change="adjustHeaders($event, headerInDialog[index].value)"
              ></v-checkbox>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="showHideDialog = false">
            {{ $t("crm.cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="addCommentForm" max-width="400">
      <v-card>
        <v-card-title>{{ $t("crm.add_comments") }}</v-card-title>
        <v-card-text>
          <v-divider></v-divider>
          <v-row>
            <v-col cols="12">
              <v-textarea
                :label="$t('crm.comment')"
                auto-grow
                clearable
                clear-icon="mdi-close"
                counter="1000"
                outlined
                rows="1"
                row-height="15"
                maxlength="1000"
                :error-messages="errorMessagesCommentField"
                v-model="commentFieldTextarea"
              >
              </v-textarea>
            </v-col>
            <v-col cols="12">
              <v-select
                class="select-box"
                background-color="#fff"
                :placeholder="$t('crm.comment_type')"
                outlined
                large
                hide-details
                :items="commentTypeItems"
                v-model="selectedCommentType"
                return-object
                item-text="typeName"
                :error-messages="errorMessagesCommentTypeField"
              >
                <template v-slot:append>
                  <v-icon size="30" color="#5b8ff5">mdi-chevron-down</v-icon>
                </template>
                <template v-slot:{item}>
                  <span>{{ item }}</span>
                </template>
              </v-select>
              <div
                class="v-messages theme--light red--text"
                v-if="commentTypeError"
              >
                {{ $t("field_is_required") }}
              </div>
            </v-col>
            <v-col cols="12" id="comment-email">
              <v-text-field
                v-model="email"
                :rules="[rules.email]"
                label="E-mail"
                outlined
                clearable
                counter
                maxlength="255"
                :error-messages="errorMessagesEmailField"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-divider></v-divider>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="addCommentForm = false">
            {{ $t("crm.cancel") }}
          </v-btn>

          <v-btn color="green darken-1" text @click="saveComment()">
            {{ $t("crm.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="photoGalleryModal" max-width="600">
      <v-card>
        <v-card-title class="justify-space-between">
          {{ $t("gallery") }}
          <v-btn @click="photoGalleryModal = false" text icon color="#5b8ff5">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-divider></v-divider>
          <v-row>
            <v-col
              v-for="(img, i) in photoGallery.imgs"
              :key="img.id"
              cols="12"
              sm="6"
              md="4"
            >
              <v-img :src="img.src" @click="openSlider(i--)">
                <div class="gallery__info">
                  <div class="gallery__file-name">{{ img.fileName }}</div>
                  <v-divider color="#ffffff"></v-divider>
                  <div class="gallery__create-on">{{ img.createOn }}</div>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        :download="img.fileName"
                        link
                        :href="img.src"
                        class="gallery__download"
                        icon
                        dark
                        @click.stop
                      >
                        <v-icon dark>mdi-download</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t("download") }}</span>
                  </v-tooltip>
                </div>
              </v-img>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="selectDriversDialog" max-width="320">
      <v-card>
        <v-card-title class="headline">{{
          $t("crm.selectDriver")
        }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pb-0 pt-8">
          <v-autocomplete
            v-model="driverId"
            :items="driversList"
            item-text="name"
            item-value="id"
            menu-props="auto"
            :label="$t('crm.driver')"
            outlined
            :no-data-text="$t('noDataAvailable')"
          ></v-autocomplete>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="selectDriversDialog = false"
          >
            {{ $t("cancel") }}
          </v-btn>

          <v-btn color="green darken-1" text @click="saveDrivers()">
            {{ $t("crm.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="multiSignDialog" max-width="600">
      <v-card>
        <v-card-title class="headline">{{
          $t("crm.multiSigning")
        }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pb-0 pt-8">
          <v-text-field
            v-model="multiSignCode"
            :rules="[(v) => !!v || $t('field_is_required')]"
            :label="$t('registration.code')"
            required
            outlined
            clearable
          ></v-text-field>
          <v-text-field
            v-model="multiSignEmail"
            :rules="[rules.email]"
            :label="$t('crm.attachedEmails')"
            required
            outlined
            clearable
          ></v-text-field>
          <v-textarea
            :label="$t('crm.comment')"
            rows="3"
            prepend-icon="mdi-comment"
            auto-grow
            clearable
            clear-icon="mdi-close"
            v-model="multiSignComment"
          ></v-textarea>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="multiSignDialog = false">
            {{ $t("cancel") }}
          </v-btn>

          <v-btn color="green darken-1" text @click="multiSign()">
            {{ $t("crm.sign") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar.isShow" :timeout="10000">
      <!-- {{ snackbar.text }} -->
      <div v-html="snackbar.text"></div>
      <v-btn color="white" text @click="snackbar.isShow = false">
        {{ $t("close") }}
      </v-btn>
    </v-snackbar>

    <v-dialog v-model="attchmentsDialog" max-width="600">
      <v-card>
        <v-card-title class="justify-space-between">
          {{ $t("crm.attachments") }}
          <v-btn @click="closeAttachmentsDialog()" text icon color="#5b8ff5">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-list>
          <v-list-item
            v-for="document in documentList"
            :key="document.id + document.type"
          >
            <v-list-item-action>
              <v-icon v-if="document.type === 2" large
                >mdi-file-image-outline</v-icon
              >
              <v-icon v-else-if="document.type === 1" large
                >mdi-file-pdf-box</v-icon
              >
              <v-icon v-else-if="document.type === 3" large
                >mdi-file-document-outline</v-icon
              >
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title>{{ document.name }}</v-list-item-title>
            </v-list-item-content>

            <!-- Container for Download and Delete Buttons in One Line -->
            <v-list-item-action
              style="display: flex; gap: 8px; flex-direction: row"
            >
              <!-- Download Button -->
              <v-btn
                @click="
                  downloadDocument(document.id, document.type, document.name)
                "
                depressed
                color="primary"
              >
                <v-icon color="white">mdi-download</v-icon>
                {{ $t("download") }}
              </v-btn>

              <!-- Delete Button with Confirmation -->
              <v-btn
                @click="confirmDelete(document.id)"
                depressed
                color="red"
                v-if="$isPermitted('deleteDocuments') && document.type === 4"
              >
                <v-icon color="white">mdi-delete</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>

          <!-- Delete Confirmation Dialog -->
          <v-dialog v-model="documentDeleteDialog" max-width="400">
            <v-card>
              <v-card-title class="headline">{{
                $t("crm.confirmDeletion")
              }}</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="green darken-1"
                  text
                  @click="documentDeleteDialog = false"
                >
                  {{ $t("no") }}
                </v-btn>
                <v-btn color="red darken-1" text @click="performDelete">
                  {{ $t("yes") }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-list>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isShowQRCodeDialog" width="600">
      <v-card height="600">
        <div
          v-if="!QRCodeSrc"
          class="d-flex justify-center align-center"
          style="height: 100%"
        >
          <v-progress-circular
            :size="50"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </div>
        <v-img v-if="QRCodeSrc" :src="QRCodeSrc"></v-img>
      </v-card>
    </v-dialog>

    <OrderNewAttachDialog
      :open="isShowNewAttachmentDialog"
      :selected-cmr-list="selectedCmrList"
      @onClose="closeNewAttachmentDialog"
    />

    <SpotCharterDialog
      :open="isSpotCharterModalOpen"
      :selectedCmrList="selectedCmrList"
      @onClose="closeSportChartedDialog"
    />
  </div>
</template>

<script>
import { i18n } from "@/plugins/i18n";
import config from "../../config";
import Axios from "axios";
import OrdersEditModal from "./OrdersEditModal";
import OrderNewAttachDialog from "./OrderNewAttachDialog.vue";
import { CMR_STATUSES } from "@/constants/cmr";
import SpotCharterDialog from "./SpotCharterDialog.vue";

const qs = require("querystring");
const FILTERS_STORAGE_KEY = "edocs_filters_v1";

export default {
  components: { OrdersEditModal, OrderNewAttachDialog, SpotCharterDialog },
  data() {
    return {
      documentDeleteDialog: false, // Controls the visibility of document delete confirmation dialog
      documentToDelete: null, // Holds the ID of the document to be deleted
      payload: {
        Code: "",
        Begin: null,
        End: null,
        Sender: "",
        Carrier: "",
        Recipient: "",
        TripID: "",
        StatusList: "",
        Page: 1,
        Limit: 10,
        OrderBy: "lastModified",
        Direction: "desc",
        Search: "",
        Assign: true,
        UnAssign: true,
        PeriodSearch: 3,
      },
      editDialog: false,
      deleteDialog: false,
      showSearch: false,
      showPioniraForm: false,
      pioniraCmrCode: "",
      pioniraComment: "",
      loading: false,
      options: {
        sortBy: ["lastModified"],
        sortDesc: ["desc"],
      },
      selectedFilter: null,
      showCmrCodeFilter: false,
      showRecOrgNameFilter: false,
      showStatusNameFilter: false,
      cmrCodeText: "",
      orgNameText: "",
      itemID: 0,
      signForm: false,
      errorMessagesCodeField: "",
      codeFieldText: "",
      item: {},
      commentFieldText: "",
      cmrID: 0,
      goodListItem: [],
      goodListTotal: 0,
      canUseSpotCharter: false,
      goodsHeaders: [
        {
          text: this.$i18n.t("crm.tbl_code"),
          value: "code",
          width: "1%",
          align: "left",
          sortable: false,
        },
        {
          text: this.$i18n.t("crm.goods_nature"),
          value: "goodsNature",
          width: "1%",
          align: "left",
        },
        {
          text: this.$i18n.t("crm.gross_weight"),
          value: "grossWeight",
          width: "1%",
          align: "left",
        },
        {
          text: this.$i18n.t("crm.marks"),
          value: "marks",
          width: "1%",
          align: "left",
        },
        {
          text: this.$i18n.t("crm.packages_number"),
          value: "packagesNumber",
          width: "1%",
          align: "left",
        },
        {
          text: this.$i18n.t("crm.packing_method"),
          value: "packingMethod",
          width: "1%",
          align: "left",
        },
        {
          text: this.$i18n.t("crm.statistic_number"),
          value: "statisticNumber",
          width: "1%",
          align: "left",
        },
        {
          text: this.$i18n.t("crm.volume"),
          value: "volume",
          width: "1%",
          align: "left",
        },
        {
          text: this.$i18n.t("crm.approved"),
          value: "approved",
          width: "1%",
          align: "left",
          sortable: false,
        },
      ],
      optionsGoods: {
        rowsPerPageItems: 10,
      },
      returnedGoodListItem: [],
      ReturnedGoodListTotal: 0,
      returnedGoodsHeaders: [
        {
          text: this.$i18n.t("crm.tbl_code"),
          value: "code",
          width: "1%",
          align: "left",
          sortable: false,
        },
        {
          text: this.$i18n.t("crm.goods_nature"),
          value: "goodsNature",
          width: "1%",
          align: "left",
        },
        {
          text: this.$i18n.t("crm.gross_weight"),
          value: "grossWeight",
          width: "1%",
          align: "left",
        },
        {
          text: this.$i18n.t("crm.marks"),
          value: "marks",
          width: "1%",
          align: "left",
        },
        {
          text: this.$i18n.t("crm.packages_number"),
          value: "packagesNumber",
          width: "1%",
          align: "left",
        },
        {
          text: this.$i18n.t("crm.packing_method"),
          value: "packingMethod",
          width: "1%",
          align: "left",
        },
        {
          text: this.$i18n.t("crm.statistic_number"),
          value: "statisticNumber",
          width: "1%",
          align: "left",
        },
        {
          text: this.$i18n.t("crm.volume"),
          value: "volume",
          width: "1%",
          align: "left",
        },
        {
          text: this.$i18n.t("crm.approved"),
          value: "approved",
          width: "1%",
          align: "left",
          sortable: false,
        },
      ],
      optionsReturnedGoods: {
        rowsPerPageItems: 10,
      },
      containerListItem: [],
      containerListTotal: 0,
      containerHeaders: [
        {
          text: this.$i18n.t("crm.number"),
          value: "number",
          width: "1%",
          align: "left",
        },
        {
          text: this.$i18n.t("crm.seal_number"),
          value: "sealNumber",
          width: "1%",
          align: "left",
        },
        {
          text: this.$i18n.t("crm.approved"),
          value: "approved",
          width: "1%",
          align: "left",
          sortable: false,
        },
      ],
      optionsContainer: {
        rowsPerPageItems: 10,
      },
      cmrCodeValue: "",
      tripIDValue: "",
      recipientOrganizationNameValue: "",
      recipientCountryCodeValue: "",
      recipientPostalCodeValue: "",
      recipientPlaceValue: "",
      recipientStreetValue: "",
      statusNameValue: "",
      senderInstructionsValue: "",
      addDialog: false,
      output: null,
      chbxCheckedAll: false,
      checkedAll: true,
      isChbxPart: false,
      uncheckedAll: false,
      chbxFilters: [],
      resultStr: true,
      searchStr: "",
      filterStr: "",
      showHideDialog: false,
      headerInDialog: [],
      header: [],
      addCommentForm: false,
      commentItem: {},
      errorMessagesCommentField: "",
      commentFieldTextarea: "",
      commentTypeItems: [],
      selectedCommentType: null,
      errorMessagesCommentTypeField: "",
      commentTypeError: false,
      showDateFilter: false,

      modalCalendar: false,
      selectedPeriodSearch: null,
      date: [],
      periodSearchStr: "",
      pastTwoWeeksChecked: false,
      isInternalDateUpdate: false,
      rules: {
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "";
        },
      },
      errorMessagesEmailField: "",
      email: "",
      checkBoxList: [
        { id: 0, model: "chbxStatusCreated", t: "crm.status_created" },
        {
          id: 1,
          model: "chbxStatusReadySigning",
          t: "crm.status_ready_signing",
        },
        {
          id: 2,
          model: "chbxStatusSignatureShipper",
          t: "crm.status_signature_shipper",
        },
        {
          id: 3,
          model: "chbxStatusSignatureDriver",
          t: "crm.status_signature_driver",
        },
        {
          id: 4,
          model: "chbxStatusSignatureReceiver",
          t: "crm.status_signature_receiver",
        },
        { id: 5, model: "chbxStatusMailing", t: "crm.status_mailing" },
        { id: 6, model: "chbxStatusClosed", t: "crm.status_closed" },
        { id: 7, model: "chbxStatusRemoved", t: "crm.status_removed" },
        { id: 8, model: "chbxStatusAssign", t: "crm.status_assign" },
        { id: 9, model: "chbxStatusUnassign", t: "crm.status_unassign" },
        { id: 10, model: "chbxStatusUnfinished", t: "crm.status_unfinished" },
      ],
      editCrmId: null,
      photoGallery: {
        visible: false,
        imgs: [],
        index: 1,
      },
      photoGalleryModal: false,
      isReadOnly: true,
      selectedCmr: [],
      fab: false,
      isFixedOptions: false,
      driverId: "",
      driversList: [],
      selectDriversDialog: false,
      multiSignDialog: false,
      selectedCmrList: [],
      snackbar: {
        isShow: false,
        text: "",
      },
      multiSignComment: "",
      multiSignCode: "",
      multiSignEmail: "",
      selectedCmrAll: "",
      selectedCmrAllIndeterminate: false,

      documentList: [],
      attchmentsDialog: false,
      attachmentsCmrId: null,

      dateTimeBegin: "",
      dateTimeEnd: "",

      isShowQRCodeDialog: false,
      QRCodeSrc: null,

      isShowNewAttachmentDialog: false,

      isSpotCharterModalOpen: false,
    };
  },
  computed: {
    dateRangeText() {
      return this.date.join(" ~ ");
    },
    isCustomDateRange() {
      // dynamic mode is not custom
      if (this.pastTwoWeeksChecked) return false;

      if (!this.date || this.date.length !== 2) return false;

      const [defaultBegin, defaultEnd] = this.getDefaultDateRange();
      return this.date[0] !== defaultBegin || this.date[1] !== defaultEnd;
    },
    totalItems() {
      return this.$store.getters.CMR_TOTAL;
    },
    cmrData() {
      let me = this;
      let data = [];
      let statusName = "";

      const cmrList = JSON.parse(JSON.stringify(this.$store.getters.CMR_LIST));

      /* eslint-disable */
      cmrList.forEach(function(item) {
        switch (item.status) {
          case 1:
            statusName = me.$i18n.t("crm.status_created");
            break;
          case 2:
            statusName = me.$i18n.t("crm.status_ready_signing");
            break;
          case 3:
            statusName = me.$i18n.t("crm.status_signature_shipper");
            break;
          case 4:
            statusName = me.$i18n.t("crm.status_signature_driver");
            break;
          case 5:
            statusName = me.$i18n.t("crm.status_signature_receiver");
            break;
          case 6:
            statusName = me.$i18n.t("crm.status_mailing");
            break;
          case 7:
            statusName = me.$i18n.t("crm.status_closed");
            break;
          case 8:
            statusName = me.$i18n.t("crm.status_removed");
            break;
          case 9:
            statusName = me.$i18n.t("crm.status_unfinished");
            break;
          default:
            statusName = "";
            break;
        }

        item.lastModified = me.$utcToCurrentDate(item.lastModified);
        item.statusName = statusName;
        data.push(item);
      });

      return data;
    },
    periodSearchType() {
      return [
        { value: 1, name: this.$i18n.t("crm.depart") },
        { value: 2, name: this.$i18n.t("crm.arrival") },
        { value: 3, name: this.$i18n.t("crm.last_modify") },
      ];
    },
    tableHeaders() {
      const tHeader = [
        {
          text: "",
          value: "checkbox",
          width: "1%",
          align: "left",
          sortable: false,
        },
        {
          text: "",
          value: "qrCode",
          width: "1%",
          align: "left",
          sortable: false,
        },
        {
          text: "",
          value: "comment",
          width: "1%",
          align: "left",
          sortable: false,
        },
        {
          text: "",
          value: "details",
          width: "1%",
          align: "left",
          sortable: false,
        },
        {
          text: "",
          value: "edit",
          width: "1%",
          align: "left",
          sortable: false,
        },
        {
          text: "",
          value: "delete",
          width: "1%",
          align: "left",
          sortable: false,
        },
        {
          text: "",
          value: "pdfFile",
          width: "1%",
          align: "left",
          sortable: false,
        },
        {
          text: "",
          value: "sign",
          width: "1%",
          align: "left",
          sortable: false,
        },
        {
          text: this.$i18n.t("crm.pictures"),
          value: "photoCount",
          width: "1%",
          align: "left",
          sortable: false,
        },

        {
          text: this.$i18n.t("crm.attachments"),
          value: "attachmentCount",
          width: "1%",
          align: "left",
          sortable: false,
        },

        {
          text: this.$i18n.t("crm.tbl_code"),
          value: "cmrCode",
          width: "1%",
          align: "left",
        },
        {
          text: this.$i18n.t("crm.driver"),
          value: "driverUserName",
          width: "1%",
          align: "left",
        },
        {
          text: "Trip ID",
          value: "tripID",
          width: "1%",
          align: "left",
          sortable: false,
        },
        {
          text: this.$i18n.t("crm.tbl_loaded"),
          value: "loaded",
          width: "1%",
          align: "left",
          sortable: false,
        },
        {
          text: this.$i18n.t("crm.tbl_name"),
          value: "recipientOrganizationName",
          width: "1%",
          align: "left",
        },
        {
          text: this.$i18n.t("crm.tbl_country_code"),
          value: "recipientCountryCode",
          width: "1%",
          align: "left",
          sortable: false,
        },
        {
          text: this.$i18n.t("crm.tbl_postal_code"),
          value: "recipientPostalCode",
          width: "1%",
          align: "left",
          sortable: false,
        },
        {
          text: this.$i18n.t("crm.tbl_place"),
          value: "recipientPlace",
          width: "1%",
          align: "left",
          sortable: false,
        },
        {
          text: this.$i18n.t("crm.tbl_street"),
          value: "recipientStreet",
          width: "1%",
          align: "left",
          sortable: false,
        },
        {
          text: this.$i18n.t("crm.containerNumbers"),
          value: "containerNumberList",
          width: "1%",
          align: "left",
          sortable: false,
        },
        {
          text: this.$i18n.t("crm.tbl_status"),
          value: "statusName",
          width: "1%",
          align: "left",
        },
        {
          text: this.$i18n.t("crm.LastModified"),
          value: "lastModified",
          width: "1%",
          align: "left",
        },
      ];
      if (!this.$isPermitted("modifyCmrs")) {
        return tHeader.filter((el) => {
          return !(
            el.value === "edit" ||
            el.value === "delete" ||
            el.value === "checkbox"
          );
        });
      }
      if (!this.$isPermitted("deleteCmrs")) {
        return tHeader.filter((el) => !(el.value === "delete"));
      }
      if (!this.$isPermitted("signCmrs")) {
        return tHeader.filter((el) => !(el.value === "sign"));
      }

      return tHeader;
    },

    isPionira() {
      return this.$isPermitted("createPioniraCmr");
    },

    isModifyCmrs() {
      return this.$isPermitted("modifyCmrs");
    },

    allSelectedAreCanceled() {
      if (!this.selectedCmrList.length) {
        return false;
      }

      const canceledCmrList = this.selectedCmrList.filter(
        (cmr) => cmr.status === CMR_STATUSES.Closed
      );
      return this.selectedCmrList.length === canceledCmrList.length;
    },
  },

  created() {
    this.$vuetify.lang.current = i18n.locale;
    this.$store.state.cmrData = [];
    this.initFilters();
    this.canUseSpotCharter =
      localStorage.getItem("spotCharterUsingSign") === "true";
  },
  methods: {
    initFilters() {
      const restored = this.restoreFilters();

      if (!restored) {
        this.isInternalDateUpdate = true;
        this.setCurrentMonth(); // [today-14..today]
        this.isInternalDateUpdate = false;

        this.pastTwoWeeksChecked = false;
        this.saveFilters();
      }

      if (this.date && this.date.length === 2) {
        this.dateTimeBegin = this.date[0];
        this.dateTimeEnd = this.date[1];
      }

      this.applyFilter();
    },

    restoreFilters() {
      try {
        const raw = localStorage.getItem(FILTERS_STORAGE_KEY);
        if (!raw) return false;

        const stored = JSON.parse(raw);
        let restored = false;

        // 1) restore mode
        if (typeof stored.pastTwoWeeksMode === "boolean") {
          this.pastTwoWeeksChecked = stored.pastTwoWeeksMode;
          restored = true;
        }

        // 2) restore dates depending on mode
        if (this.pastTwoWeeksChecked) {
          const [begin, end] = this.getDefaultDateRange(); // today-14..today
          this.isInternalDateUpdate = true;
          this.date = [begin, end];
          this.dateTimeBegin = begin;
          this.dateTimeEnd = end;
          this.isInternalDateUpdate = false;
          restored = true;
        } else if (Array.isArray(stored.date) && stored.date.length === 2) {
          this.date = stored.date;
          this.dateTimeBegin = stored.date[0];
          this.dateTimeEnd = stored.date[1];
          restored = true;
        }

        if (Array.isArray(stored.chbxFilters)) {
          this.chbxFilters = stored.chbxFilters;
          const total = this.checkBoxList.length;
          const selected = stored.chbxFilters.length;
          this.chbxCheckedAll = selected === total;
          this.isChbxPart = selected > 0 && selected < total;
          restored = true;
        }

        if (stored.selectedPeriodSearch != null) {
          const found = this.periodSearchType.find(
            (x) => x.value === stored.selectedPeriodSearch
          );
          if (found) {
            this.selectedPeriodSearch = found;
            this.periodSearchStr = found.name;
            restored = true;
          }
        }

        return restored;
      } catch (e) {
        console.error("Failed to restore filters", e);
        return false;
      }
    },

    saveFilters() {
      try {
        const data = {
          pastTwoWeeksMode: !!this.pastTwoWeeksChecked,

          date:
            !this.pastTwoWeeksChecked && this.date && this.date.length === 2
              ? this.date
              : null,

          chbxFilters: this.chbxFilters,

          selectedPeriodSearch: this.selectedPeriodSearch
            ? this.selectedPeriodSearch.value
            : null,
        };

        localStorage.setItem(FILTERS_STORAGE_KEY, JSON.stringify(data));
      } catch (e) {
        console.error("Failed to save filters", e);
      }
    },

    closeSportChartedDialog() {
      this.isSpotCharterModalOpen = false;
    },
    handleSpotCharterModal() {
      this.isSpotCharterModalOpen = true;
    },
    isDisabledCreate() {
      return !this.$isPermitted("createCmr");
    },
    openAttachmentsDialog(cmr) {
      this.getDocumentList(cmr.id);
      this.attchmentsDialog = true;
      this.attachmentsCmrId = cmr;
    },
    closeAttachmentsDialog() {
      this.attchmentsDialog = false;
      this.documentList = [];
      this.attachmentsCmrId = null;
    },
    confirmDelete(documentId) {
      if (this.attachmentsCmrId.status >= 3) {
        const status = Object.keys(CMR_STATUSES).find(
          (key) => CMR_STATUSES[key] === this.attachmentsCmrId.status
        );
        this.snackbar.text = this.$t("crm.eDocumentStatus", { status });
        this.snackbar.isShow = true;
      } else {
        // Open confirmation dialog and store the document ID
        this.documentToDelete = documentId;
        this.documentDeleteDialog = true;
      }
    },
    performDelete() {
      // Proceed with deletion, close dialog, and reset documentToDelete
      this.deleteDocument(this.documentToDelete, this.attachmentsCmrId.id);
      this.documentDeleteDialog = false;
      this.documentToDelete = null;
    },
    deleteDocument(documentId, cmrId) {
      const formData = new FormData();
      formData.append("documentId", documentId);
      formData.append("cmrId", cmrId);

      Axios.post(`${config.apiBaseUrl}api/cmr/delete-document`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      })
        .then((response) => {
          if (response.status === 200) {
            this.documentList = this.documentList.filter(
              (doc) => doc.id !== documentId
            );
            this.snackbar.text = this.$t("Document deleted successfully.");
            this.snackbar.isShow = true;
            // Refresh the main list after successful deletion
            this.reloadCmr();
          }
        })
        .catch((error) => {
          //console.log(error);
          alert(error.response.data);
          this.snackbar.text = this.$t("Can not delete document");
          this.snackbar.isShow = true;
        });
    },
    getDocumentList(id) {
      Axios.get(config.apiBaseUrl + `api/cmr/document-list`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
        params: {
          cmr_id: id,
        },
      })
        .then(({ status, data }) => {
          if (status === 200) {
            this.documentList = data;
          }
        })
        .catch((error) => {
          /* eslint-disable */
          //console.log(error);
          alert(error.response.data);
        });
    },
    downloadDocument(id, type, name) {
      Axios.get(config.apiBaseUrl + `api/cmr/download-document`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
        responseType: "blob",
        params: {
          documentId: id,
          type: type,
        },
      })
        .then(({ status, data }) => {
          if (status === 200) {
            const url = URL.createObjectURL(data);
            let link = document.createElement("a");
            link.download = name;
            link.href = url;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setTimeout(() => URL.revokeObjectURL(url), 1000);
            link = null;
          }
        })
        .catch((error) => {
          /* eslint-disable */
          //console.log(error);
          alert(error.response.data);
        });
    },
    cancelCalendar() {
      this.modalCalendar = false;
      this.date = [];
    },
    saveComment() {
      let data = {};
      if (this.commentFieldTextarea === "") {
        this.errorMessagesCommentField = this.$i18n.t("field_is_required");
        return;
      }

      if (this.selectedCommentType === null) {
        this.errorMessagesCommentTypeField = this.$i18n.t("field_is_required");
        this.commentTypeError = true;
        return;
      }

      data.cmr_id = this.commentItem.id;
      data.comment = this.commentFieldTextarea;
      data.CommentType = this.selectedCommentType.value;
      data.email = this.email;

      this.$store.dispatch("SET_COMMENTS", data);
      this.addCommentForm = false;
    },
    showCommentForm(item) {
      let me = this;
      this.commentTypeItems = [];
      let typeName = "";
      this.addCommentForm = true;
      this.commentFieldTextarea = "";
      this.errorMessagesCommentField = "";
      this.errorMessagesCommentTypeField = "";
      this.commentTypeError = false;
      this.selectedCommentType = null;
      this.commentItem = item;

      Axios.get(config.apiBaseUrl + "api/cmr/comment-type?cmr_id=" + item.id, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function(response) {
          if (response.status === 200) {
            response.data.forEach(function(item) {
              switch (item.value) {
                case 9:
                  typeName = me.$i18n.t("crm.comment");
                  break;
                case 10:
                  typeName = me.$i18n.t("crm.shipper_comment");
                  break;
                case 11:
                  typeName = me.$i18n.t("crm.driver_comment");
                  break;
                case 12:
                  typeName = me.$i18n.t("crm.receiver_comment");
                  break;
              }

              me.commentTypeItems.push({
                value: item.value,
                typeName: typeName,
              });
            });
          }
        })
        .catch(function(error) {
          alert(error.response.data);
          me.$store.state.loading = false;
        });
    },
    showHideHeaders() {
      let me = this;
      me.showHideDialog = true;
      me.headerInDialog = [];

      me.tableHeaders.forEach(function(item) {
        if (item.text.length > 0) {
          me.headerInDialog.push({
            text: item.text,
            value: item.value,
            selected: true,
          });
        }
      });
    },
    adjustHeaders(val, i) {
      console.log(val, i, this.headerInDialog);
    },
    selectAll(e) {
      if (this.chbxCheckedAll) {
        this.chbxFilters = [];
      } else {
        if (this.isChbxPart) {
          e.preventDefault();
          this.chbxCheckedAll = false;
          this.isChbxPart = false;
          this.chbxFilters = [];
        } else {
          this.chbxFilters = [
            "chbxStatusCreated",
            "chbxStatusSignatureReceiver",
            "chbxStatusAssign",
            "chbxStatusReadySigning",
            "chbxStatusMailing",
            "chbxStatusUnassign",
            "chbxStatusSignatureShipper",
            "chbxStatusClosed",
            "chbxStatusSignatureDriver",
            "chbxStatusRemoved",
            "chbxStatusUnfinished",
          ];
        }
      }
    },
    showFilterSearchForm() {
      this.showSearch = true;
      this.showStatusNameFilter = true;
      this.showDateFilter = true;
    },
    showPionira() {
      this.showPioniraForm = !this.showPioniraForm;
    },
    printOrder() {
      this.$htmlToPaper("print-order-table");
    },
    openAddForm() {
      this.addDialog = true;
    },
    saveOrder() {},
    editDisabled(item) {
      if (!this.$isPermitted("modifyCmrs")) return true;
      return !(
        item.status === 1 ||
        item.status === 2 ||
        item.status === 3 ||
        item.status === 4
      );
    },
    deleteDisabled() {
      return !this.$isPermitted("deleteCmrs");
    },
    signDisabled() {
      return this.showSigningBtn();
    },
    statusNameColor(item) {
      let color;
      switch (item.status) {
        case 1:
          color = "#230bf0";
          break;
        case 2:
          color = "71a951";
          break;
        case 3:
          color = "#f8d619";
          break;
        case 4:
          color = "#ee19f8";
          break;
        case 5:
          color = "#8b0bf0";
          break;
        case 6:
          color = "#0bedf0";
          break;
        case 7:
          color = "#078b8d";
          break;
        case 8:
          color = "#078b8d";
          break;
        case 9:
          color = "#5b8ff5";
          break;
        default:
          color = "#edf00b";
          break;
      }

      return { color: color };
    },
    editItem(item) {
      this.editDialog = true;
      this.editCrmId = item.id;
      this.isReadOnly = false;
    },
    addItem() {
      this.editDialog = true;
      this.editCrmId = null;
      this.isReadOnly = false;
    },
    itemDetails(item) {
      this.editDialog = true;
      this.editCrmId = item.id;
      this.isReadOnly = true;
    },
    itemDelete(item) {
      this.itemID = item.id;
      this.deleteDialog = true;
    },
    removeItem() {
      this.deleteDialog = false;
      Axios.get(config.apiBaseUrl + "api/cmr/delete?id=" + this.itemID, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then((response) => {
          if (response.status === 200) {
            this.applyFilter();
            this.itemID = 0;
            this.snackbar.text = this.$i18n.t("crm.deleted");
            this.snackbar.isShow = true;
          }
        })
        .catch(function(error) {
          alert(error.response.data);
          this.$store.state.loading = false;
        });
    },
    hideFilter() {
      this.showStatusNameFilter = false;
      this.showSearch = false;
      this.statusStr = "";
      this.filterStr = "";
      this.resultStr = false;
      this.searchStr = "";
      this.chbxCheckedAll = false;
      this.chbxFilters = [];
      this.showDateFilter = false;
      this.date = [];
      this.selectedPeriodSearch = null;
      this.options.page = 1;
      this.payload = this.payloadDefault();
      this.payload.Limit = this.options.itemsPerPage;
      this.$store.dispatch("GET_CMR", this.payload);
    },
    payloadDefault() {
      return {
        Code: "",
        Begin: null,
        End: null,
        Sender: "",
        Carrier: "",
        Recipient: "",
        TripID: "",
        StatusList: "",
        Page: 1,
        Limit: 10,
        OrderBy: "lastModified",
        Direction: "desc",
        Search: "",
        Assign: true,
        UnAssign: true,
        PeriodSearch: 3,
      };
    },
    applyFilter() {
      let statusStr = "";
      let filterStr = "";
      this.payload = this.payloadDefault();
      const $this = this;

      this.chbxFilters.forEach((el) => {
        if (el === "chbxStatusCreated") {
          statusStr += "1,";
          filterStr += $this.$i18n.t("crm.status_created") + ", ";
        }
        if (el === "chbxStatusReadySigning") {
          statusStr += "2,";
          filterStr += $this.$i18n.t("crm.status_ready_signing") + ", ";
        }
        if (el === "chbxStatusSignatureShipper") {
          statusStr += "3,";
          filterStr += $this.$i18n.t("crm.status_signature_shipper") + ", ";
        }
        if (el === "chbxStatusSignatureDriver") {
          statusStr += "4,";
          filterStr += $this.$i18n.t("crm.status_signature_driver") + ", ";
        }
        if (el === "chbxStatusSignatureReceiver") {
          statusStr += "5,";
          filterStr += $this.$i18n.t("crm.status_signature_receiver") + ", ";
        }
        if (el === "chbxStatusMailing") {
          statusStr += "6,";
          filterStr += $this.$i18n.t("crm.status_mailing") + ", ";
        }
        if (el === "chbxStatusClosed") {
          statusStr += "7,";
          filterStr += $this.$i18n.t("crm.status_closed") + ", ";
        }
        if (el === "chbxStatusRemoved") {
          statusStr += "8,";
          filterStr += $this.$i18n.t("crm.status_removed") + ", ";
        }
        if (el === "chbxStatusUnfinished") {
          statusStr += "9,";
          filterStr += $this.$i18n.t("crm.status_unfinished") + ", ";
        }
      });

      if (statusStr.length > 0)
        this.payload.StatusList = statusStr.substring(0, statusStr.length - 1);

      if (
        localStorage.getItem("role").toLocaleLowerCase() ===
        "goverment authority user"
      ) {
        this.payload.Code = this.searchStr;
      } else {
        this.payload.Search = this.searchStr;
      }

      this.payload.Assign =
        this.chbxFilters.length === 0
          ? true
          : this.chbxFilters.includes("chbxStatusAssign");
      this.payload.UnAssign =
        this.chbxFilters.length === 0
          ? true
          : this.chbxFilters.includes("chbxStatusUnassign");

      this.resultStr = true;

      if (this.chbxFilters.includes("chbxStatusAssign"))
        filterStr += this.$i18n.t("crm.status_assign") + ", ";
      if (this.chbxFilters.includes("chbxStatusUnassign"))
        filterStr += this.$i18n.t("crm.status_unassign") + ", ";
      if (filterStr.length > 0)
        this.filterStr = filterStr.substring(0, filterStr.length - 2);

      if (this.date.length > 0) {
        if (this.date.length === 1) {
          this.payload.Begin = this.date[0];
        } else {
          let dateBegin = new Date(this.date[0]);
          let dateEnd = new Date(this.date[1]);
          if (dateBegin <= dateEnd) {
            this.payload.Begin = this.date[0];
            this.payload.End = this.date[1];
          } else {
            this.payload.Begin = this.date[1];
            this.payload.End = this.date[0];
            this.date = [this.date[1], this.date[0]];
          }
        }
      }

      if (this.selectedPeriodSearch !== null) {
        this.payload.PeriodSearch = this.selectedPeriodSearch.value;
        this.periodSearchStr = this.selectedPeriodSearch.name;
      }

      this.showStatusNameFilter = false;
      this.showSearch = false;
      this.showDateFilter = false;
      this.options.page = 1;
      this.selectedCmr = [];
      this.selectedCmrList = [];
      this.isFixedOptions = false;
      this.payload.Limit = this.options.itemsPerPage;

      // save current filter settings to localStorage
      this.saveFilters();

      this.$store.dispatch("GET_CMR", this.payload);
    },
    clearPeriodSearch() {
      this.selectedPeriodSearch = null;
      this.periodSearchStr = "";

      // when clearing, we immediately save the filters and re-query the list
      this.saveFilters();
      this.applyFilter();
    },
    generatePdf(item) {
      this.$store.dispatch("GET_PDF", item.id);
    },
    signDocument(item) {
      this.signForm = true;
      this.item = item;
      this.errorMessagesCodeField = "";
      this.codeFieldText = "";
      this.commentFieldText = "";
    },
    buildSingleSignatureMessage(data, cmr) {
      const cmrCode = cmr && cmr.cmrCode ? cmr.cmrCode : data.cmrId;
      const lines = [];

      lines.push(`
    <div class="signature-message__header">
      📄 <strong>CMR ${cmrCode}</strong>
    </div>
  `);

      if (data.requiresConfirmation) {
        lines.push(`
      <div class="signature-message__line signature-message__line--confirm">
        📱 ${this.$i18n.t("crm.signatureRequiresMobileConfirmation")}
      </div>
    `);
      } else {
        lines.push(`
      <div class="signature-message__line signature-message__line--success">
        ✅ ${this.$i18n.t("crm.signatureCompletedSuccessfully")}
      </div>
    `);
      }

      if (data.warning) {
        lines.push(`
      <div class="signature-message__line signature-message__line--warning">
        ⚠️ <strong>${this.$i18n.t("crm.warning")}:</strong> ${data.warning}
      </div>
    `);
      }

      if (data.info) {
        lines.push(`
      <div class="signature-message__line signature-message__line--info">
        ℹ️ <strong>${this.$i18n.t("crm.info")}:</strong> ${data.info}
      </div>
    `);
      }

      return `
    <div class="signature-message">
      ${lines.join("")}
    </div>
  `;
    },
    buildMultiSignatureMessage(results) {
      const blocks = [];

      results.forEach((item) => {
        const cmr = this.selectedCmrList.find((x) => x.id === item.cmrId);
        const cmrCode = cmr && cmr.cmrCode ? cmr.cmrCode : item.cmrId;

        const lines = [];

        lines.push(`
      <div class="signature-message__header">
        📄 <strong>CMR ${cmrCode}</strong>
      </div>
    `);

        if (item.error) {
          lines.push(`
        <div class="signature-message__line signature-message__line--error">
          ❌ ${item.error}
        </div>
      `);
        } else {
          if (item.requiresConfirmation) {
            lines.push(`
          <div class="signature-message__line signature-message__line--confirm">
            📱 ${this.$i18n.t("crm.signatureRequiresMobileConfirmation")}
          </div>
        `);
          } else {
            lines.push(`
          <div class="signature-message__line signature-message__line--success">
            ✅ ${this.$i18n.t("crm.signatureCompletedSuccessfully")}
          </div>
        `);
          }

          if (item.warning) {
            lines.push(`
          <div class="signature-message__line signature-message__line--warning">
            ⚠️ ${item.warning}
          </div>
        `);
          }

          if (item.info) {
            lines.push(`
          <div class="signature-message__line signature-message__line--info">
            ℹ️ ${item.info}
          </div>
        `);
          }
        }

        blocks.push(`
      <div class="signature-message">
        ${lines.join("")}
      </div>
    `);
      });

      return blocks.join(`<div class="signature-message__divider"></div>`);
    },
    async saveSign() {
      let data = {};

      if (this.codeFieldText.length === 0) {
        this.errorMessagesCodeField = this.$i18n.t(
          "crm.error_code_required_msg"
        );
        return;
      }

      if (this.codeFieldText.length < 4) {
        this.errorMessagesCodeField = this.$i18n.t("crm.error_code_length_msg");
        return;
      }

      data.cmr_id = this.item.id;
      data.guid = localStorage.getItem("guid");
      data.code = this.codeFieldText;
      data.comment = this.commentFieldText;

      try {
        let response = null;

        if (this.item.status === 2) {
          response = await this.$store.dispatch("SIGNATURE_SHIPPER", data);
        }

        if (this.item.status === 4) {
          response = await this.$store.dispatch("SIGNATURE_RECEIVER", data);
        }

        if (this.item.status === 3) {
          response = await this.$store.dispatch("SIGNATURE_DRIVER", data);
        }

        if (response && response.status === 200) {
          this.snackbar.text = this.buildSingleSignatureMessage(
            response.data,
            this.item
          );
          this.snackbar.isShow = true;
        }

        this.signForm = false;
      } catch (error) {
        /*const errorMessage =
          error.response && error.response.data && error.response.data.error
            ? error.response.data.error
            : error.response && error.response.data
            ? error.response.data
            : error.message;

        const cmrCode =
          this.item && this.item.cmrCode ? this.item.cmrCode : this.item.id;

        this.snackbar.text = `<strong>CMR ${cmrCode} ${this.$i18n.t(
          "crm.error"
        )}:</strong> ${errorMessage}`;

        this.snackbar.isShow = true;*/
      }
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57 || keyCode === 46 || keyCode === 192) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    showSighihgButton() {
      if (!this.$isPermitted("signCmrs")) {
        return "display: none";
      }
      return "";
    },
    getGoodList(data) {
      let me = this;
      Axios.post(config.apiBaseUrl + "api/good/list", qs.stringify(data), {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function(response) {
          if (response.status === 200) {
            me.goodListItem = response.data.data;
            me.goodListTotal = response.data.total;
            me.$store.state.loading = false;
          }
        })
        .catch(function(error) {
          alert(error.response.data);
          me.$store.state.loading = false;
        });
    },
    getReturnedGoodList(data) {
      let me = this;
      Axios.post(config.apiBaseUrl + "api/good/list", qs.stringify(data), {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function(response) {
          if (response.status === 200) {
            me.returnedGoodListItem = response.data.data;
            me.ReturnedGoodListTotal = response.data.total;
            me.$store.state.loading = false;
          }
        })
        .catch(function() {
          me.$store.state.loading = false;
        });
    },
    getContainerList(data) {
      let me = this;
      Axios.post(config.apiBaseUrl + "api/container/list", qs.stringify(data), {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function(response) {
          if (response.status === 200) {
            me.containerListItem = response.data.data;
            me.containerListTotal = response.data.total;
            me.$store.state.loading = false;
          }
        })
        .catch(function(error) {
          alert(error.response.data);
          me.$store.state.loading = false;
        });
    },
    removeFilterItem(el) {
      this.chbxFilters = this.chbxFilters.filter((item) => item !== el);
      this.applyFilter();
      this.selectedCmr = this.selectedCmr.filter((cmrId) => {
        const cmrItem = this.cmrData.find((cmr) => cmr.id === cmrId);
        const cmrItemStatus = cmrItem.status;
        return this.payload.StatusList.includes(`${cmrItemStatus}`);
      });
    },
    getFilterName(val) {
      return this.$i18n.t(this.checkBoxList.find((el) => el.model === val).t);
    },
    removeFilterItemStr() {
      this.searchStr = "";
      this.applyFilter();
    },
    removeFilterItemData() {
      this.date = [];
      this.applyFilter();
    },
    removeFilterAll() {
      this.searchStr = "";
      this.date = [];
      this.chbxFilters = [];
      this.periodSearchStr = "";
      this.selectedPeriodSearch = null;
      this.applyFilter();
      this.selectedCmr = [];
    },
    closeEditModal(snackbar) {
      this.editDialog = false;
      if (snackbar) {
        this.snackbar = Object.assign({}, snackbar);
      }
    },
    openPhotoGallery(item) {
      const $this = this;
      Axios.get(config.apiBaseUrl + "api/cmr/photo-list?cmr_id=" + item.id, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function(response) {
          if (response.status === 200) {
            $this.photoGallery.imgs = response.data.map((el) => {
              return {
                id: el.id,
                src: `data:image/png;base64,${el.photo}`,
                createOn: el.createOn,
                fileName: el.fileName,
              };
            });
            $this.photoGalleryModal = true;
          }
        })
        .catch(function(error) {
          // setError(error)
          alert(error.response.data);
        });
    },
    openSlider(i) {
      this.photoGallery.index = i;
      this.photoGallery.visible = true;
    },
    hideHandlerPhotoGallery() {
      this.photoGallery.visible = false;
    },
    downloadFile(img) {
      window.location.href = img.replace(
        "image/png",
        "application/octet-stream"
      );
    },

    addDriversMass() {
      if (this.selectedCmrList.length > 0) {
        const organisationId = this.selectedCmrList[0].carrierOrganizationsID;
        const isOneOrganisation = this.selectedCmrList.every(
          (el) => el.carrierOrganizationsID === organisationId
        );
        if (isOneOrganisation) {
          this.getAllDrivers();
          this.selectDriversDialog = true;
        } else {
          alert(this.$i18n.t("crm.addedDriversError"));
        }
      }
    },

    signMass() {
      if (this.selectedCmrList.length > 1) {
        const status = this.selectedCmrList[0].status;
        const isSameStatus = this.selectedCmrList.every(
          (el) => el.status === status
        );
        if (isSameStatus) {
          if (status === 2 || status === 4) {
            this.multiSignDialog = true;
            return;
          }
          if (
            status === 3 &&
            (this.isPlanner() || this.$isPermitted("signCmrs"))
          ) {
            this.multiSignDialog = true;
          } else {
            alert(this.$i18n.t("crm.signMassError2"));
          }
        } else {
          alert(this.$i18n.t("crm.signMassError"));
        }
      }
    },

    multiSign() {
      const status = this.selectedCmrList[0].status;
      let url = config.apiBaseUrl;
      const data = {};

      data.cmr_id = this.selectedCmrList.reduce(
        (prev, el) => (prev === "" ? el.id : `${prev},${el.id}`),
        ""
      );
      data.guid = localStorage.getItem("guid");
      data.comment = this.multiSignComment;
      data.code = this.multiSignCode;
      data.email = this.multiSignEmail;
      if (status === 2) {
        url += "api/cmr/multy-signature-shipper";
      } else if (status === 3) {
        url += "api/cmr/multy-signature-driver";
      } else if (status === 4) {
        url += "api/cmr/multy-signature-receiver";
      } else {
        alert(this.$i18n.t("crm.signMassError2"));
        return;
      }
      this.$store.state.loading = true;
      Axios.post(url, qs.stringify(data), {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then((response) => {
          if (response.status === 200) {
            const message = this.buildMultiSignatureMessage(response.data);

            this.selectedCmr = [];
            this.selectedCmrList = [];
            this.isFixedOptions = false;
            this.multiSignDialog = false;
            this.multiSignComment = "";
            this.multiSignCode = "";
            this.multiSignEmail = "";

            this.snackbar.text = message;
            this.snackbar.isShow = true;

            this.$store.dispatch("GET_CMR", this.payload);
          }

          this.$store.state.loading = false;
        })
        .catch((error) => {
          if (
            error.response &&
            error.response.data &&
            Array.isArray(error.response.data)
          ) {
            this.snackbar.text = this.buildMultiSignatureMessage(
              error.response.data
            );
          } else {
            const errorMessage =
              error.response && error.response.data && error.response.data.error
                ? error.response.data.error
                : error.response && error.response.data
                ? error.response.data
                : error.message;

            this.snackbar.text = `
      <div class="signature-message">
        <div class="signature-message__line signature-message__line--error">
          ❌ <strong>${this.$i18n.t("crm.error")}:</strong> ${errorMessage}
        </div>
      </div>
    `;
          }

          this.snackbar.isShow = true;
          this.$store.state.loading = false;
        });
    },

    getAllDrivers() {
      const $this = this;
      const organizationId = $this.selectedCmrList[0]
        .subcontractorOrganizationsID
        ? $this.selectedCmrList[0].subcontractorOrganizationsID
        : $this.selectedCmrList[0].carrierOrganizationsID;

      Axios.get(
        config.apiBaseUrl +
          "api/employee/driver-list?organization_id=" +
          organizationId,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      )
        .then(function(response) {
          if (response.status === 200) {
            $this.driversList = response.data.map((el) => {
              return { id: el.guid, name: el.userName };
            });
          }
        })
        .catch(function(error) {
          /* eslint-disable */
          alert(error.response.data);
        });
    },

    saveDrivers() {
      const cmrs = this.selectedCmrList.reduce(
        (res, el) => (res === "" ? el.id : res + "," + el.id),
        ""
      );

      Axios.get(
        config.apiBaseUrl +
          "api/cmr/set-driver-guid?cmr_id=" +
          cmrs +
          "&guid=" +
          this.driverId,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            this.selectedCmr = [];
            this.selectedCmrList = [];
            this.isFixedOptions = false;
            this.selectDriversDialog = false;
            this.$store.dispatch("GET_CMR", this.payload);
          }
        })
        .catch((error) => alert(error.response.data));
    },
    reloadCmr() {
      this.$store.dispatch("GET_CMR", this.payload);
    },

    applyPionira() {
      this.$store.state.loading = true;
      const data = {
        code: this.pioniraCmrCode,
        remarks: this.pioniraComment,
      };
      Axios.post(
        config.apiBaseUrl + "api/cmr/create-pionira",
        qs.stringify(data),
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            this.$store.state.loading = false;
            this.snackbar.text = this.$i18n.t("crm.updated");
            this.snackbar.isShow = true;
            this.applyFilter();
          }
        })
        .catch((error) => {
          this.$store.state.loading = false;
          alert(`${this.$i18n.t("error_400")}  -  ${error.response.data}`);
        });
    },

    isSigningUser() {
      return (
        localStorage.getItem("role").toLocaleLowerCase() === "signing user"
      );
    },

    isPlanner() {
      return localStorage.getItem("role").toLocaleLowerCase() === "planner";
    },

    isAdmin() {
      const isSuperAdmin =
        localStorage.getItem("role").toLocaleLowerCase() === "super admin" ||
        localStorage.getItem("role").toLocaleLowerCase() === "super admin plus";
      const isCompanyAdmin =
        localStorage.getItem("role").toLocaleLowerCase() === "company admin" ||
        localStorage.getItem("role").toLocaleLowerCase() ===
          "company admin plus";
      return isSuperAdmin || isCompanyAdmin;
    },

    showSigningBtn() {
      if (this.selectedCmr.length > 1) {
        if (this.isSigningUser()) {
          return true;
        } else if (this.$isPermitted("signCmrs")) {
          return true;
        } else if (this.isPlanner()) {
          return true;
        }
        return false;
      }
      return false;
    },

    showDriverBtn() {
      if (this.selectedCmr.length > 0) {
        if (this.isPlanner()) {
          return true;
        } else if (this.isAdmin()) {
          return true;
        }
        return false;
      }
      return false;
    },

    showSetToUnfinishedBtn() {
      if (
        this.selectedCmr.length > 0 &&
        this.selectedCmrList.find((cmr) => cmr.status === 3 || cmr.status === 4)
      ) {
        return true;
      }
      return false;
    },

    showSetToPrevStatusBtn() {
      if (
        this.selectedCmr.length > 0 &&
        this.selectedCmrList.find((cmr) => cmr.status === 9)
      ) {
        return true;
      }
      return false;
    },

    SetToPrevStatus() {
      const selectedCmrParam = this.selectedCmr.join();

      Axios.get(config.apiBaseUrl + "api/cmr/cancel-unfinished", {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
        params: {
          cmr_id: selectedCmrParam,
        },
      })
        .then((response) => {
          if (response.status === 200) {
            alert(response.data);
            this.selectedCmr = [];
            this.selectedCmrList = [];
            this.isFixedOptions = false;
            this.selectDriversDialog = false;
            this.$store.dispatch("GET_CMR", this.payload);
          }
        })
        .catch((error) => alert(error.response.data));
    },
    SetToUnfinished() {
      const selectedCmrParam = this.selectedCmr.join();

      Axios.get(config.apiBaseUrl + "api/cmr/set-unfinished", {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
        params: {
          cmr_id: selectedCmrParam,
        },
      })
        .then((response) => {
          if (response.status === 200) {
            alert(response.data);
            this.selectedCmr = [];
            this.selectedCmrList = [];
            this.isFixedOptions = false;
            this.selectDriversDialog = false;
            this.$store.dispatch("GET_CMR", this.payload);
          }
        })
        .catch((error) => alert(error.response.data));
    },
    getDefaultDateRange() {
      const currentDate = new Date();
      const prevDate = new Date();
      prevDate.setDate(prevDate.getDate() - 14);

      const defaultBegin = prevDate.toISOString().split("T")[0];
      const defaultEnd = currentDate.toISOString().split("T")[0];

      return [defaultBegin, defaultEnd];
    },

    setCurrentMonth() {
      const [begin, end] = this.getDefaultDateRange();

      this.dateTimeBegin = begin;
      this.dateTimeEnd = end;
      this.date = [begin, end];
    },
    getQRCode(item) {
      this.QRCodeSrc = null;
      this.isShowQRCodeDialog = true;
      let cmrCodesQueryParam = "";

      if (item) {
        cmrCodesQueryParam = item.cmrCode;
      }
      if (!item) {
        cmrCodesQueryParam = this.selectedCmrList
          .map((item) => item.cmrCode)
          .join();
      }

      Axios.get(config.apiBaseUrl + "code-image", {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
        params: {
          code: cmrCodesQueryParam,
        },
        responseType: "blob",
      })
        .then(({ status, data }) => {
          if (status === 200) {
            this.QRCodeSrc = URL.createObjectURL(data);
          }
        })
        .catch((error) => alert(error.response.data));
    },

    openNewAttachmentDialog() {
      this.isShowNewAttachmentDialog = true;
    },
    closeNewAttachmentDialog(withReload) {
      this.isShowNewAttachmentDialog = false;
      if (withReload) {
        this.reloadCmr();
      }
    },

    //---end methods
  },
  watch: {
    options: {
      handler() {
        if (this.$store.state.loading) {
          return;
        }

        this.$store.state.loading = true;
        this.payload.Page = this.options.page;
        this.payload.Limit = this.options.itemsPerPage;

        let sortByLength = this.options.sortBy.length;
        let sortDescLength = this.options.sortDesc.length;

        if (sortByLength > 0) {
          if (this.options.sortBy[0] === "statusName") {
            this.payload.OrderBy = "status";
          } else this.payload.OrderBy = this.options.sortBy[0];
        }
        if (sortDescLength > 0) {
          if (this.options.sortDesc[0]) {
            this.payload.Direction = "desc";
          }
        } else {
          this.payload.Direction = "asc";
        }

        this.payload.Begin = this.date[0];
        this.payload.End = this.date[1];

        this.$store.dispatch("GET_CMR", this.payload);
      },
      deep: true,
    },
    optionsGoods: {
      handler() {
        let data = {};
        this.$store.state.loading = true;
        data.cmrID = this.cmrID;
        data.Page = this.optionsGoods.page;
        data.Limit = this.optionsGoods.itemsPerPage;
        data.goodType = 1;

        let sortByLength = this.optionsGoods.sortBy.length;
        let sortDescLength = this.optionsGoods.sortDesc.length;

        if (sortByLength > 0) {
          data.OrderBy = this.optionsGoods.sortBy[0];
        }

        if (sortDescLength > 0) {
          if (this.optionsGoods.sortDesc[0]) {
            data.Direction = "desc";
          }
        } else {
          data.Direction = "asc";
        }

        this.getGoodList(data);
      },
      deep: true,
    },
    optionsReturnedGoods: {
      handler() {
        let data = {};
        this.$store.state.loading = true;
        data.cmrID = this.cmrID;
        data.Page = this.optionsReturnedGoods.page;
        data.Limit = this.optionsReturnedGoods.itemsPerPage;
        data.goodType = 2;

        let sortByLength = this.optionsReturnedGoods.sortBy.length;
        let sortDescLength = this.optionsReturnedGoods.sortDesc.length;

        if (sortByLength > 0) {
          data.OrderBy = this.optionsReturnedGoods.sortBy[0];
        }

        if (sortDescLength > 0) {
          if (this.optionsReturnedGoods.sortDesc[0]) {
            data.Direction = "desc";
          }
        } else {
          data.Direction = "asc";
        }

        this.getReturnedGoodList(data);
      },
      deep: true,
    },
    optionsContainer: {
      handler() {
        let data = {};
        this.$store.state.loading = true;
        data.cmrID = this.cmrID;
        data.Page = this.optionsContainer.page;
        data.Limit = this.optionsContainer.itemsPerPage;

        let sortByLength = this.optionsContainer.sortBy.length;
        let sortDescLength = this.optionsContainer.sortDesc.length;

        if (sortByLength > 0) {
          data.OrderBy = this.optionsContainer.sortBy[0];
        }

        if (sortDescLength > 0) {
          if (this.optionsContainer.sortDesc[0]) {
            data.Direction = "desc";
          }
        } else {
          data.Direction = "asc";
        }

        this.getContainerList(data);
      },
      deep: true,
    },
    "$i18n.locale"() {
      if (this.selectedPeriodSearch) {
        const value = this.selectedPeriodSearch.value;
        const updated = this.periodSearchType.find((x) => x.value === value);
        if (updated) {
          this.selectedPeriodSearch = updated;
        }
      }

      if (this.selectedPeriodSearch) {
        this.periodSearchStr = this.selectedPeriodSearch.name;
      } else {
        this.periodSearchStr = "";
      }
    },
    commentFieldTextarea(val) {
      if (val.length > 0) this.errorMessagesCommentField = "";
    },
    selectedCommentType() {
      this.errorMessagesCommentTypeField = "";
      this.commentTypeError = false;
    },
    chbxFilters(val) {
      const boo = val.length === this.checkBoxList.length;
      this.chbxCheckedAll = boo;
      this.isChbxPart = val.length === 0 ? false : !boo;
    },

    selectedCmr(v) {
      this.selectedCmrList = this.cmrData.filter((el) => v.includes(el.id));

      this.isFixedOptions = this.selectedCmrList.length > 0;

      if (this.selectedCmrList.length !== 0) {
        this.selectedCmrAllIndeterminate =
          this.selectedCmrList.length !== this.cmrData.length;
      } else {
        this.selectedCmrAllIndeterminate = false;
      }
    },

    selectedCmrAll(v) {
      if (v) {
        this.selectedCmrList = [...this.cmrData];
        this.selectedCmr = this.cmrData.map((el) => el.id);
      } else {
        this.selectedCmrList = [];
        this.selectedCmr = [];
      }

      this.isFixedOptions = this.selectedCmrList.length > 0;
    },
    date: {
      handler(val) {
        if (this.isInternalDateUpdate) return;
        if (!Array.isArray(val) || val.length !== 2) return;

        this.dateTimeBegin = val[0];
        this.dateTimeEnd = val[1];

        // If Past 2 Weeks is enabled, check if the range is the default.
        if (this.pastTwoWeeksChecked) {
          const [defBegin, defEnd] = this.getDefaultDateRange();
          const isDefault = val[0] === defBegin && val[1] === defEnd;

          if (!isDefault) {
            // user created a custom range
            this.pastTwoWeeksChecked = false;
            this.saveFilters();
          }
        }
      },
      deep: true,
    },

    pastTwoWeeksChecked(newVal, oldVal) {
      if (newVal === oldVal) return;

      // enabled -> dynamic mode
      if (newVal) {
        const [begin, end] = this.getDefaultDateRange();

        this.isInternalDateUpdate = true;
        this.date = [begin, end];
        this.dateTimeBegin = begin;
        this.dateTimeEnd = end;
        this.isInternalDateUpdate = false;

        this.saveFilters();
        return;
      }

      // turned off -> remains on the current date as static
      this.saveFilters();
    },

    // end watch --------------------------------------------------------------------------
  },
};
</script>

<style scoped>
.date-range-custom-chip {
  color: red !important;
}

.past-two-weeks-col {
  display: flex;
  align-items: flex-start !important;
}

.past-two-weeks-checkbox {
  margin: 0;
  margin-top: 20px;
}

::v-deep .signature-message {
  padding: 8px 0;
  line-height: 1.45;
}

::v-deep .signature-message__header {
  font-weight: 600;
  margin-bottom: 6px;
}

::v-deep .signature-message__line {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin: 3px 0;
}

::v-deep .signature-message__line--confirm {
  color: #dce9ff;
}

::v-deep .signature-message__line--success {
  color: #d8f7e5;
}

::v-deep .signature-message__line--warning {
  color: #ffe88a;
}

::v-deep .signature-message__line--info {
  color: #b9dcff;
}

::v-deep .signature-message__line--error {
  color: #ffb3b3;
}

::v-deep .signature-message__divider {
  border-top: 1px solid rgba(255, 255, 255, 0.35);
  margin: 8px 0;
}
</style>
